var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmapInsuranceAgency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.56,
    height: 31.758,
    viewBox: "0 0 34.56 31.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-insurance-agency",
    "data-name": "Icon map-insurance-agency",
    d: "M18.368,2.082.913,16.56H5.04V33.84H30.96V16.56h4.513ZM22.278,28.8H14.107l1.714-7.712a3.764,3.764,0,0,1-1.714-3.132,3.988,3.988,0,0,1,4.085-3.916,4.043,4.043,0,0,1,4.086,3.982,3.627,3.627,0,0,1-1.713,3.054Z",
    transform: "translate(-0.913 -2.082)",
    fill: "#0c8de0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmapInsuranceAgency);
export default __webpack_public_path__ + "static/media/Icon map-insurance-agency.b3e9cf9bb6fd7453ea0e645ca6d46829.svg";
export { ForwardRef as ReactComponent };